<template>
  <div
    style="
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    "
    v-if="!bluValue || !btcValue"
  >
    {{ $t("msg.loading") }}...
  </div>

  <span v-else>
    <span class="price">
      {{ (bluValue[0].value).toFixed(2) }}
      <strong>USDT</strong> |
    </span>
    <span class="price" v-if="fundValueBtc">
      {{ (fundValueBtc.tokenPrice).toFixed(6) }}
      <strong>BTC</strong>
    </span>
  </span>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  created() {},
  data: () => ({}),
  methods: {},
  computed: {
    ...mapGetters([
      "bluAccount",
      "btcAccount",
      "bluValue",
      "btcValue",
      "fundValueBtc",
    ]),
  },
  watch: {
    currencies: function () {
      this.getCoinsAmount();
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/public/BluPricesHeader.vue